// This file is auto-generated by @hey-api/openapi-ts

import type { Options as ClientOptions, TDataShape, Client } from "./client";
import type {
  DeleteAccountDataData,
  PostAuthRegisterData,
  PostAuthRegisterResponses,
  PostAuthSendMagicLinkData,
  PostAuthVerifyMagicLinkData,
  PostAuthVerifyMagicLinkResponses,
  PostAuthMfaSendData,
  PostAuthMfaSendResponses,
  PostAuthMfaVerifyData,
  PostAuthMfaVerifyResponses,
  GetAuthMfaStatusData,
  GetAuthMfaStatusResponses,
  PostAuthPasswordForgotData,
  PostAuthPasswordResetData,
  PostAuthPatientAcceptInviteData,
  PostAuthPatientAcceptInviteResponses,
  GetAuthPatientStatusData,
  GetAuthPatientStatusResponses,
  PostAuthPatientVerifyIdentityData,
  GetAuthMeData,
  GetAuthMeResponses,
  PostAuthRevokeSessionsData,
  PostAuthCreateMobileRecordingSessionData,
  PostAuthCreateMobileRecordingSessionResponses,
  PostAuthExchangeMobileRecordingTokenData,
  PostAuthExchangeMobileRecordingTokenResponses,
  PostClientCreateData,
  PostClientCreateResponses,
  GetClientGetData,
  GetClientGetResponses,
  GetClientListData,
  GetClientListResponses,
  PostClientUpdateData,
  DeleteClientDeleteData,
  PostClientReactivateData,
  DeleteClientPurgeData,
  PostClientRotateKeyData,
  PostClientRotateKeyResponses,
  GetClientExportData,
  GetClientExportResponses,
  PostClientCheckOwnershipData,
  PostClientCheckOwnershipResponses,
  PostClientPortalInviteData,
  PostClientPortalInviteResponses,
  PostClientAccessGrantData,
  PostClientAccessRevokeData,
  GetClientAccessListData,
  GetClientAccessListResponses,
  PostClientConsentRequestData,
  PostClientConsentRequestResponses,
  GetClientConsentGetData,
  GetClientConsentGetResponses,
  PostClientConsentSubmitData,
  PostClientConsentSubmitResponses,
  GetClientConsentHistoryData,
  GetClientConsentHistoryResponses,
  PostClientTransfersInitiateData,
  GetClientTransfersOutgoingData,
  GetClientTransfersOutgoingResponses,
  GetClientTransfersIncomingData,
  GetClientTransfersIncomingResponses,
  PostClientTransfersByTransferIdCancelData,
  PostClientTransfersByTransferIdAcceptData,
  PostClientTransfersByTransferIdAcceptResponses,
  PostClientTransfersByTransferIdDeclineData,
  DeleteEventByEventIdData,
  DeleteEventByEventIdResponses,
  DeleteEventByClientIdByEventIdVersionsByVersionIdData,
  PostEventsCreateData,
  PostEventsAutosaveData,
  PostEventsAutosaveResponses,
  PostEventsCommitVersionData,
  PostEventsCommitVersionResponses,
  PostEventsUpdateTemplateData,
  PostEventsUpdateTemplateResponses,
  PostEventsUpdateReferencesData,
  PostEventsUpdateReferencesResponses,
  PostEventsUpdateTitleData,
  PostEventsUpdateTitleResponses,
  PostEventsBatchData,
  PostEventsBatchResponses,
  GetEventsByClientIdByEventIdData,
  GetEventsByClientIdByEventIdResponses,
  GetEventsByClientIdByEventIdVersionsData,
  GetEventsByClientIdByEventIdVersionsResponses,
  DeleteOrgData,
  PostOrgData,
  GetOrgListData,
  GetOrgListResponses,
  PostOrgActiveData,
  PatchOrgNameData,
  GetOrgMembersData,
  GetOrgMembersResponses,
  PostOrgMembersLeaveData,
  DeleteOrgMembersByUserIdData,
  GetOrgMembersByUserIdData,
  GetOrgMembersByUserIdResponses,
  PatchOrgMembersByUserIdRoleData,
  PatchOrgMembersByUserIdRoleResponses,
  GetOrgInvitesData,
  GetOrgInvitesResponses,
  PostOrgInvitesData,
  DeleteOrgInvitesByInviteIdData,
  PostOrgInvitesByInviteIdAcceptData,
  PostOrgInvitesByInviteIdRejectData,
  PostOrgInvitesByInviteIdResendData,
  PostSessionTriggerAiSummaryData,
  GetStripeCheckSubscriptionStatusData,
  GetStripeCheckSubscriptionStatusResponses,
  PostStripeCreateSubscriptionIntentData,
  PostStripeCreateSubscriptionIntentResponses,
  PostStripeConfirmSubscriptionData,
  PostStripeConfirmSubscriptionResponses,
  PostStripeCustomerPortalData,
  PostStripeCustomerPortalResponses,
  PostStripeCancelSubscriptionData,
  PostStripeCancelSubscriptionResponses,
  GetStripeInvoicesData,
  GetStripeInvoicesResponses,
  GetSupportThreadsData,
  GetSupportThreadsResponses,
  GetSupportThreadsByThreadIdData,
  GetSupportThreadsByThreadIdResponses,
  PostSupportThreadsByThreadIdCloseData,
  DeleteSupportThreadsByThreadIdMessagesByMessageIdAttachmentsByIndexData,
  DeleteSupportThreadsByThreadIdMessagesByMessageIdAttachmentsByIndexResponses,
  PostTemplatesCreateData,
  GetTemplatesListData,
  GetTemplatesListResponses,
  DeleteTemplatesByTemplateIdData,
  DeleteTemplatesByTemplateIdResponses,
  GetTemplatesByTemplateIdData,
  GetTemplatesByTemplateIdResponses,
  PatchTemplatesByTemplateIdData,
  PatchTemplatesByTemplateIdResponses,
  PostTranscriptionStartData,
  PostTranscriptionStartResponses,
  PostTranscriptionMockCompleteData,
  PostTranscriptionUploadData,
  PostTranscriptionUploadResponses,
  PatchTranscriptionTextData,
  PatchTranscriptionTextResponses,
  PatchTranscriptionSpeakerLabelData,
  PatchTranscriptionSpeakerLabelResponses,
  PostTranscriptionDeleteData,
  PostTranscriptionDeleteResponses,
  GetTranscriptionGetData,
  GetTranscriptionGetResponses,
  GetUsageSummaryData,
  GetUsageSummaryResponses,
  GetAssignmentsDefsData,
  GetAssignmentsDefsResponses,
  PostAssignmentsDefsData,
  PostAssignmentsDefsResponses,
  PatchAssignmentsDefsByDefIdData,
  PostAssignmentsDefsByDefIdActiveData,
  GetAssignmentsListData,
  GetAssignmentsListResponses,
  PostAssignmentsAssignData,
  PostAssignmentsAssignResponses,
  DeleteAssignmentsByIdData,
  PostAssignmentsByIdReviewData,
  PostAssignmentsByIdAdministerData,
  PostAssignmentsByIdAdministerResponses,
  GetAssignmentsMineData,
  GetAssignmentsMineResponses,
  PostAssignmentsByIdSubmitData,
  PostAssignmentsByIdCompleteData,
  PostAssignmentsByIdAcknowledgeData,
  GetSharedDocumentsMineData,
  GetSharedDocumentsMineResponses,
  GetSharedDocumentsMineByIdData,
  GetSharedDocumentsMineByIdResponses,
  PostSharedDocumentsCreateData,
  PostSharedDocumentsCreateResponses,
  GetSharedDocumentsEventByEventIdData,
  GetSharedDocumentsEventByEventIdResponses,
  PutSharedDocumentsByIdData,
  PostSharedDocumentsByIdGenerateData,
  PostSharedDocumentsByIdGenerateResponses,
  PostSharedDocumentsByIdShareData,
  PostSharedDocumentsByIdUnshareData,
  GetUserData,
  GetUserResponses,
  PatchUserData,
  PatchUserResponses,
  GetUserInvitesData,
  GetUserInvitesResponses,
  GetUserTransfersData,
  GetUserTransfersResponses,
  PostUserRequestEmailChangeData,
  PostUserRequestEmailChangeResponses,
  PostUserConfirmEmailChangeData,
  PostUserConfirmEmailChangeResponses,
  GetUserTotpStatusData,
  GetUserTotpStatusResponses,
  PostUserSetupTotpData,
  PostUserSetupTotpResponses,
  PostUserConfirmTotpSetupData,
  PostUserDisableTotpData,
  PostUserVerifyTotpData,
  PostUserPreferencesResetPdfData,
  PostUserPreferencesResetPdfResponses,
  GetHealthData,
  GetHealthResponses,
} from "./types.gen";
import { client as _heyApiClient } from "./client.gen";

export type Options<
  TData extends TDataShape = TDataShape,
  ThrowOnError extends boolean = boolean,
> = ClientOptions<TData, ThrowOnError> & {
  /**
   * You can provide a client instance returned by `createClient()` instead of
   * individual options. This might be also useful if you want to implement a
   * custom client.
   */
  client?: Client;
  /**
   * You can pass arbitrary values through the `meta` object. This can be
   * used to access values that aren't defined as part of the SDK function.
   */
  meta?: Record<string, unknown>;
};

export const deleteAccountData = <ThrowOnError extends boolean = false>(
  options?: Options<DeleteAccountDataData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).delete<
    unknown,
    unknown,
    ThrowOnError
  >({
    url: "/account/data",
    ...options,
  });
};

export const postAuthRegister = <ThrowOnError extends boolean = false>(
  options: Options<PostAuthRegisterData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    PostAuthRegisterResponses,
    unknown,
    ThrowOnError
  >({
    url: "/auth/register",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

export const postAuthSendMagicLink = <ThrowOnError extends boolean = false>(
  options: Options<PostAuthSendMagicLinkData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>(
    {
      url: "/auth/send-magic-link",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    }
  );
};

export const postAuthVerifyMagicLink = <ThrowOnError extends boolean = false>(
  options: Options<PostAuthVerifyMagicLinkData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    PostAuthVerifyMagicLinkResponses,
    unknown,
    ThrowOnError
  >({
    url: "/auth/verify-magic-link",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

export const postAuthMfaSend = <ThrowOnError extends boolean = false>(
  options?: Options<PostAuthMfaSendData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).post<
    PostAuthMfaSendResponses,
    unknown,
    ThrowOnError
  >({
    url: "/auth/mfa/send",
    ...options,
  });
};

export const postAuthMfaVerify = <ThrowOnError extends boolean = false>(
  options: Options<PostAuthMfaVerifyData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    PostAuthMfaVerifyResponses,
    unknown,
    ThrowOnError
  >({
    url: "/auth/mfa/verify",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

export const getAuthMfaStatus = <ThrowOnError extends boolean = false>(
  options?: Options<GetAuthMfaStatusData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    GetAuthMfaStatusResponses,
    unknown,
    ThrowOnError
  >({
    url: "/auth/mfa/status",
    ...options,
  });
};

export const postAuthPasswordForgot = <ThrowOnError extends boolean = false>(
  options: Options<PostAuthPasswordForgotData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>(
    {
      url: "/auth/password/forgot",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    }
  );
};

export const postAuthPasswordReset = <ThrowOnError extends boolean = false>(
  options: Options<PostAuthPasswordResetData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>(
    {
      url: "/auth/password/reset",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    }
  );
};

export const postAuthPatientAcceptInvite = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostAuthPatientAcceptInviteData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    PostAuthPatientAcceptInviteResponses,
    unknown,
    ThrowOnError
  >({
    url: "/auth/patient/accept-invite",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

export const getAuthPatientStatus = <ThrowOnError extends boolean = false>(
  options?: Options<GetAuthPatientStatusData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    GetAuthPatientStatusResponses,
    unknown,
    ThrowOnError
  >({
    url: "/auth/patient/status",
    ...options,
  });
};

export const postAuthPatientVerifyIdentity = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostAuthPatientVerifyIdentityData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>(
    {
      url: "/auth/patient/verify-identity",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    }
  );
};

export const getAuthMe = <ThrowOnError extends boolean = false>(
  options?: Options<GetAuthMeData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    GetAuthMeResponses,
    unknown,
    ThrowOnError
  >({
    url: "/auth/me",
    ...options,
  });
};

export const postAuthRevokeSessions = <ThrowOnError extends boolean = false>(
  options?: Options<PostAuthRevokeSessionsData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).post<
    unknown,
    unknown,
    ThrowOnError
  >({
    url: "/auth/revoke-sessions",
    ...options,
  });
};

export const postAuthCreateMobileRecordingSession = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostAuthCreateMobileRecordingSessionData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    PostAuthCreateMobileRecordingSessionResponses,
    unknown,
    ThrowOnError
  >({
    url: "/auth/create-mobile-recording-session",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

export const postAuthExchangeMobileRecordingToken = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostAuthExchangeMobileRecordingTokenData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    PostAuthExchangeMobileRecordingTokenResponses,
    unknown,
    ThrowOnError
  >({
    url: "/auth/exchange-mobile-recording-token",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

export const postClientCreate = <ThrowOnError extends boolean = false>(
  options: Options<PostClientCreateData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    PostClientCreateResponses,
    unknown,
    ThrowOnError
  >({
    url: "/client/create",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

export const getClientGet = <ThrowOnError extends boolean = false>(
  options: Options<GetClientGetData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    GetClientGetResponses,
    unknown,
    ThrowOnError
  >({
    url: "/client/get",
    ...options,
  });
};

export const getClientList = <ThrowOnError extends boolean = false>(
  options?: Options<GetClientListData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    GetClientListResponses,
    unknown,
    ThrowOnError
  >({
    url: "/client/list",
    ...options,
  });
};

export const postClientUpdate = <ThrowOnError extends boolean = false>(
  options: Options<PostClientUpdateData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>(
    {
      url: "/client/update",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    }
  );
};

export const deleteClientDelete = <ThrowOnError extends boolean = false>(
  options: Options<DeleteClientDeleteData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).delete<
    unknown,
    unknown,
    ThrowOnError
  >({
    url: "/client/delete",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

export const postClientReactivate = <ThrowOnError extends boolean = false>(
  options: Options<PostClientReactivateData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>(
    {
      url: "/client/reactivate",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    }
  );
};

export const deleteClientPurge = <ThrowOnError extends boolean = false>(
  options: Options<DeleteClientPurgeData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).delete<
    unknown,
    unknown,
    ThrowOnError
  >({
    url: "/client/purge",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

export const postClientRotateKey = <ThrowOnError extends boolean = false>(
  options: Options<PostClientRotateKeyData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    PostClientRotateKeyResponses,
    unknown,
    ThrowOnError
  >({
    url: "/client/rotate-key",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

export const getClientExport = <ThrowOnError extends boolean = false>(
  options: Options<GetClientExportData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    GetClientExportResponses,
    unknown,
    ThrowOnError
  >({
    url: "/client/export",
    ...options,
  });
};

export const postClientCheckOwnership = <ThrowOnError extends boolean = false>(
  options: Options<PostClientCheckOwnershipData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    PostClientCheckOwnershipResponses,
    unknown,
    ThrowOnError
  >({
    url: "/client/check-ownership",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

export const postClientPortalInvite = <ThrowOnError extends boolean = false>(
  options: Options<PostClientPortalInviteData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    PostClientPortalInviteResponses,
    unknown,
    ThrowOnError
  >({
    url: "/client/portal-invite",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

export const postClientAccessGrant = <ThrowOnError extends boolean = false>(
  options: Options<PostClientAccessGrantData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>(
    {
      url: "/client/access/grant",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    }
  );
};

export const postClientAccessRevoke = <ThrowOnError extends boolean = false>(
  options: Options<PostClientAccessRevokeData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>(
    {
      url: "/client/access/revoke",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    }
  );
};

export const getClientAccessList = <ThrowOnError extends boolean = false>(
  options?: Options<GetClientAccessListData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    GetClientAccessListResponses,
    unknown,
    ThrowOnError
  >({
    url: "/client/access/list",
    ...options,
  });
};

export const postClientConsentRequest = <ThrowOnError extends boolean = false>(
  options: Options<PostClientConsentRequestData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    PostClientConsentRequestResponses,
    unknown,
    ThrowOnError
  >({
    url: "/client/consent/request",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

export const getClientConsentGet = <ThrowOnError extends boolean = false>(
  options: Options<GetClientConsentGetData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    GetClientConsentGetResponses,
    unknown,
    ThrowOnError
  >({
    url: "/client/consent/get",
    ...options,
  });
};

export const postClientConsentSubmit = <ThrowOnError extends boolean = false>(
  options: Options<PostClientConsentSubmitData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    PostClientConsentSubmitResponses,
    unknown,
    ThrowOnError
  >({
    url: "/client/consent/submit",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

export const getClientConsentHistory = <ThrowOnError extends boolean = false>(
  options: Options<GetClientConsentHistoryData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    GetClientConsentHistoryResponses,
    unknown,
    ThrowOnError
  >({
    url: "/client/consent/history",
    ...options,
  });
};

export const postClientTransfersInitiate = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostClientTransfersInitiateData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>(
    {
      url: "/client/transfers/initiate",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    }
  );
};

export const getClientTransfersOutgoing = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<GetClientTransfersOutgoingData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    GetClientTransfersOutgoingResponses,
    unknown,
    ThrowOnError
  >({
    url: "/client/transfers/outgoing",
    ...options,
  });
};

export const getClientTransfersIncoming = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<GetClientTransfersIncomingData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    GetClientTransfersIncomingResponses,
    unknown,
    ThrowOnError
  >({
    url: "/client/transfers/incoming",
    ...options,
  });
};

export const postClientTransfersByTransferIdCancel = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<PostClientTransfersByTransferIdCancelData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).post<
    unknown,
    unknown,
    ThrowOnError
  >({
    url: "/client/transfers/{transfer_id}/cancel",
    ...options,
  });
};

export const postClientTransfersByTransferIdAccept = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<PostClientTransfersByTransferIdAcceptData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).post<
    PostClientTransfersByTransferIdAcceptResponses,
    unknown,
    ThrowOnError
  >({
    url: "/client/transfers/{transfer_id}/accept",
    ...options,
  });
};

export const postClientTransfersByTransferIdDecline = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<PostClientTransfersByTransferIdDeclineData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).post<
    unknown,
    unknown,
    ThrowOnError
  >({
    url: "/client/transfers/{transfer_id}/decline",
    ...options,
  });
};

export const deleteEventByEventId = <ThrowOnError extends boolean = false>(
  options: Options<DeleteEventByEventIdData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).delete<
    DeleteEventByEventIdResponses,
    unknown,
    ThrowOnError
  >({
    url: "/event/{event_id}",
    ...options,
  });
};

export const deleteEventByClientIdByEventIdVersionsByVersionId = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<
    DeleteEventByClientIdByEventIdVersionsByVersionIdData,
    ThrowOnError
  >
) => {
  return (options?.client ?? _heyApiClient).delete<
    unknown,
    unknown,
    ThrowOnError
  >({
    url: "/event/{client_id}/{event_id}/versions/{version_id}",
    ...options,
  });
};

export const postEventsCreate = <ThrowOnError extends boolean = false>(
  options: Options<PostEventsCreateData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>(
    {
      url: "/events/create",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    }
  );
};

export const postEventsAutosave = <ThrowOnError extends boolean = false>(
  options: Options<PostEventsAutosaveData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    PostEventsAutosaveResponses,
    unknown,
    ThrowOnError
  >({
    url: "/events/autosave",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

export const postEventsCommitVersion = <ThrowOnError extends boolean = false>(
  options: Options<PostEventsCommitVersionData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    PostEventsCommitVersionResponses,
    unknown,
    ThrowOnError
  >({
    url: "/events/commit-version",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

export const postEventsUpdateTemplate = <ThrowOnError extends boolean = false>(
  options: Options<PostEventsUpdateTemplateData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    PostEventsUpdateTemplateResponses,
    unknown,
    ThrowOnError
  >({
    url: "/events/update-template",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

export const postEventsUpdateReferences = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostEventsUpdateReferencesData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    PostEventsUpdateReferencesResponses,
    unknown,
    ThrowOnError
  >({
    url: "/events/update-references",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

export const postEventsUpdateTitle = <ThrowOnError extends boolean = false>(
  options: Options<PostEventsUpdateTitleData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    PostEventsUpdateTitleResponses,
    unknown,
    ThrowOnError
  >({
    url: "/events/update-title",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

export const postEventsBatch = <ThrowOnError extends boolean = false>(
  options: Options<PostEventsBatchData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    PostEventsBatchResponses,
    unknown,
    ThrowOnError
  >({
    url: "/events/batch",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

export const getEventsByClientIdByEventId = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<GetEventsByClientIdByEventIdData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    GetEventsByClientIdByEventIdResponses,
    unknown,
    ThrowOnError
  >({
    url: "/events/{client_id}/{event_id}",
    ...options,
  });
};

export const getEventsByClientIdByEventIdVersions = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<GetEventsByClientIdByEventIdVersionsData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    GetEventsByClientIdByEventIdVersionsResponses,
    unknown,
    ThrowOnError
  >({
    url: "/events/{client_id}/{event_id}/versions",
    ...options,
  });
};

export const deleteOrg = <ThrowOnError extends boolean = false>(
  options?: Options<DeleteOrgData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).delete<
    unknown,
    unknown,
    ThrowOnError
  >({
    url: "/org",
    ...options,
  });
};

export const postOrg = <ThrowOnError extends boolean = false>(
  options: Options<PostOrgData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>(
    {
      url: "/org",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    }
  );
};

export const getOrgList = <ThrowOnError extends boolean = false>(
  options?: Options<GetOrgListData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    GetOrgListResponses,
    unknown,
    ThrowOnError
  >({
    url: "/org/list",
    ...options,
  });
};

export const postOrgActive = <ThrowOnError extends boolean = false>(
  options?: Options<PostOrgActiveData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).post<
    unknown,
    unknown,
    ThrowOnError
  >({
    url: "/org/active",
    ...options,
  });
};

export const patchOrgName = <ThrowOnError extends boolean = false>(
  options: Options<PatchOrgNameData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).patch<
    unknown,
    unknown,
    ThrowOnError
  >({
    url: "/org/name",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

export const getOrgMembers = <ThrowOnError extends boolean = false>(
  options?: Options<GetOrgMembersData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    GetOrgMembersResponses,
    unknown,
    ThrowOnError
  >({
    url: "/org/members",
    ...options,
  });
};

export const postOrgMembersLeave = <ThrowOnError extends boolean = false>(
  options?: Options<PostOrgMembersLeaveData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).post<
    unknown,
    unknown,
    ThrowOnError
  >({
    url: "/org/members/leave",
    ...options,
  });
};

export const deleteOrgMembersByUserId = <ThrowOnError extends boolean = false>(
  options?: Options<DeleteOrgMembersByUserIdData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).delete<
    unknown,
    unknown,
    ThrowOnError
  >({
    url: "/org/members/{user_id}",
    ...options,
  });
};

export const getOrgMembersByUserId = <ThrowOnError extends boolean = false>(
  options?: Options<GetOrgMembersByUserIdData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    GetOrgMembersByUserIdResponses,
    unknown,
    ThrowOnError
  >({
    url: "/org/members/{user_id}",
    ...options,
  });
};

export const patchOrgMembersByUserIdRole = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchOrgMembersByUserIdRoleData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).patch<
    PatchOrgMembersByUserIdRoleResponses,
    unknown,
    ThrowOnError
  >({
    url: "/org/members/{user_id}/role",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

export const getOrgInvites = <ThrowOnError extends boolean = false>(
  options?: Options<GetOrgInvitesData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    GetOrgInvitesResponses,
    unknown,
    ThrowOnError
  >({
    url: "/org/invites",
    ...options,
  });
};

export const postOrgInvites = <ThrowOnError extends boolean = false>(
  options: Options<PostOrgInvitesData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>(
    {
      url: "/org/invites",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    }
  );
};

export const deleteOrgInvitesByInviteId = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<DeleteOrgInvitesByInviteIdData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).delete<
    unknown,
    unknown,
    ThrowOnError
  >({
    url: "/org/invites/{invite_id}",
    ...options,
  });
};

export const postOrgInvitesByInviteIdAccept = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<PostOrgInvitesByInviteIdAcceptData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).post<
    unknown,
    unknown,
    ThrowOnError
  >({
    url: "/org/invites/{invite_id}/accept",
    ...options,
  });
};

export const postOrgInvitesByInviteIdReject = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<PostOrgInvitesByInviteIdRejectData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).post<
    unknown,
    unknown,
    ThrowOnError
  >({
    url: "/org/invites/{invite_id}/reject",
    ...options,
  });
};

export const postOrgInvitesByInviteIdResend = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<PostOrgInvitesByInviteIdResendData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).post<
    unknown,
    unknown,
    ThrowOnError
  >({
    url: "/org/invites/{invite_id}/resend",
    ...options,
  });
};

export const postSessionTriggerAiSummary = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostSessionTriggerAiSummaryData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>(
    {
      url: "/session/trigger-ai-summary",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    }
  );
};

export const getStripeCheckSubscriptionStatus = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<GetStripeCheckSubscriptionStatusData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    GetStripeCheckSubscriptionStatusResponses,
    unknown,
    ThrowOnError
  >({
    url: "/stripe/check-subscription-status",
    ...options,
  });
};

export const postStripeCreateSubscriptionIntent = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostStripeCreateSubscriptionIntentData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    PostStripeCreateSubscriptionIntentResponses,
    unknown,
    ThrowOnError
  >({
    url: "/stripe/create-subscription-intent",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

export const postStripeConfirmSubscription = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostStripeConfirmSubscriptionData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    PostStripeConfirmSubscriptionResponses,
    unknown,
    ThrowOnError
  >({
    url: "/stripe/confirm-subscription",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

export const postStripeCustomerPortal = <ThrowOnError extends boolean = false>(
  options: Options<PostStripeCustomerPortalData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    PostStripeCustomerPortalResponses,
    unknown,
    ThrowOnError
  >({
    url: "/stripe/customer-portal",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

export const postStripeCancelSubscription = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<PostStripeCancelSubscriptionData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).post<
    PostStripeCancelSubscriptionResponses,
    unknown,
    ThrowOnError
  >({
    url: "/stripe/cancel-subscription",
    ...options,
  });
};

export const getStripeInvoices = <ThrowOnError extends boolean = false>(
  options?: Options<GetStripeInvoicesData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    GetStripeInvoicesResponses,
    unknown,
    ThrowOnError
  >({
    url: "/stripe/invoices",
    ...options,
  });
};

export const getSupportThreads = <ThrowOnError extends boolean = false>(
  options?: Options<GetSupportThreadsData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    GetSupportThreadsResponses,
    unknown,
    ThrowOnError
  >({
    url: "/support/threads",
    ...options,
  });
};

export const getSupportThreadsByThreadId = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<GetSupportThreadsByThreadIdData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    GetSupportThreadsByThreadIdResponses,
    unknown,
    ThrowOnError
  >({
    url: "/support/threads/{thread_id}",
    ...options,
  });
};

export const postSupportThreadsByThreadIdClose = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<PostSupportThreadsByThreadIdCloseData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).post<
    unknown,
    unknown,
    ThrowOnError
  >({
    url: "/support/threads/{thread_id}/close",
    ...options,
  });
};

export const deleteSupportThreadsByThreadIdMessagesByMessageIdAttachmentsByIndex =
  <ThrowOnError extends boolean = false>(
    options?: Options<
      DeleteSupportThreadsByThreadIdMessagesByMessageIdAttachmentsByIndexData,
      ThrowOnError
    >
  ) => {
    return (options?.client ?? _heyApiClient).delete<
      DeleteSupportThreadsByThreadIdMessagesByMessageIdAttachmentsByIndexResponses,
      unknown,
      ThrowOnError
    >({
      url: "/support/threads/{thread_id}/messages/{message_id}/attachments/{index}",
      ...options,
    });
  };

export const postTemplatesCreate = <ThrowOnError extends boolean = false>(
  options: Options<PostTemplatesCreateData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>(
    {
      url: "/templates/create",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    }
  );
};

export const getTemplatesList = <ThrowOnError extends boolean = false>(
  options?: Options<GetTemplatesListData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    GetTemplatesListResponses,
    unknown,
    ThrowOnError
  >({
    url: "/templates/list",
    ...options,
  });
};

export const deleteTemplatesByTemplateId = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<DeleteTemplatesByTemplateIdData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).delete<
    DeleteTemplatesByTemplateIdResponses,
    unknown,
    ThrowOnError
  >({
    url: "/templates/{template_id}",
    ...options,
  });
};

export const getTemplatesByTemplateId = <ThrowOnError extends boolean = false>(
  options?: Options<GetTemplatesByTemplateIdData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    GetTemplatesByTemplateIdResponses,
    unknown,
    ThrowOnError
  >({
    url: "/templates/{template_id}",
    ...options,
  });
};

export const patchTemplatesByTemplateId = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchTemplatesByTemplateIdData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).patch<
    PatchTemplatesByTemplateIdResponses,
    unknown,
    ThrowOnError
  >({
    url: "/templates/{template_id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

export const postTranscriptionStart = <ThrowOnError extends boolean = false>(
  options: Options<PostTranscriptionStartData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    PostTranscriptionStartResponses,
    unknown,
    ThrowOnError
  >({
    url: "/transcription/start",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

export const postTranscriptionMockComplete = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostTranscriptionMockCompleteData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>(
    {
      url: "/transcription/mock-complete",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    }
  );
};

export const postTranscriptionUpload = <ThrowOnError extends boolean = false>(
  options: Options<PostTranscriptionUploadData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    PostTranscriptionUploadResponses,
    unknown,
    ThrowOnError
  >({
    url: "/transcription/upload",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

export const patchTranscriptionText = <ThrowOnError extends boolean = false>(
  options: Options<PatchTranscriptionTextData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).patch<
    PatchTranscriptionTextResponses,
    unknown,
    ThrowOnError
  >({
    url: "/transcription/text",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

export const patchTranscriptionSpeakerLabel = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchTranscriptionSpeakerLabelData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).patch<
    PatchTranscriptionSpeakerLabelResponses,
    unknown,
    ThrowOnError
  >({
    url: "/transcription/speaker-label",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

export const postTranscriptionDelete = <ThrowOnError extends boolean = false>(
  options: Options<PostTranscriptionDeleteData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    PostTranscriptionDeleteResponses,
    unknown,
    ThrowOnError
  >({
    url: "/transcription/delete",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

export const getTranscriptionGet = <ThrowOnError extends boolean = false>(
  options: Options<GetTranscriptionGetData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    GetTranscriptionGetResponses,
    unknown,
    ThrowOnError
  >({
    url: "/transcription/get",
    ...options,
  });
};

export const getUsageSummary = <ThrowOnError extends boolean = false>(
  options?: Options<GetUsageSummaryData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    GetUsageSummaryResponses,
    unknown,
    ThrowOnError
  >({
    url: "/usage/summary",
    ...options,
  });
};

export const getAssignmentsDefs = <ThrowOnError extends boolean = false>(
  options?: Options<GetAssignmentsDefsData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    GetAssignmentsDefsResponses,
    unknown,
    ThrowOnError
  >({
    url: "/assignments/defs",
    ...options,
  });
};

export const postAssignmentsDefs = <ThrowOnError extends boolean = false>(
  options: Options<PostAssignmentsDefsData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    PostAssignmentsDefsResponses,
    unknown,
    ThrowOnError
  >({
    url: "/assignments/defs",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

export const patchAssignmentsDefsByDefId = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAssignmentsDefsByDefIdData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).patch<
    unknown,
    unknown,
    ThrowOnError
  >({
    url: "/assignments/defs/{def_id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

export const postAssignmentsDefsByDefIdActive = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostAssignmentsDefsByDefIdActiveData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>(
    {
      url: "/assignments/defs/{def_id}/active",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    }
  );
};

export const getAssignmentsList = <ThrowOnError extends boolean = false>(
  options: Options<GetAssignmentsListData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    GetAssignmentsListResponses,
    unknown,
    ThrowOnError
  >({
    url: "/assignments/list",
    ...options,
  });
};

export const postAssignmentsAssign = <ThrowOnError extends boolean = false>(
  options: Options<PostAssignmentsAssignData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    PostAssignmentsAssignResponses,
    unknown,
    ThrowOnError
  >({
    url: "/assignments/assign",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

export const deleteAssignmentsById = <ThrowOnError extends boolean = false>(
  options?: Options<DeleteAssignmentsByIdData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).delete<
    unknown,
    unknown,
    ThrowOnError
  >({
    url: "/assignments/{id}",
    ...options,
  });
};

export const postAssignmentsByIdReview = <ThrowOnError extends boolean = false>(
  options?: Options<PostAssignmentsByIdReviewData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).post<
    unknown,
    unknown,
    ThrowOnError
  >({
    url: "/assignments/{id}/review",
    ...options,
  });
};

export const postAssignmentsByIdAdminister = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostAssignmentsByIdAdministerData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    PostAssignmentsByIdAdministerResponses,
    unknown,
    ThrowOnError
  >({
    url: "/assignments/{id}/administer",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

export const getAssignmentsMine = <ThrowOnError extends boolean = false>(
  options?: Options<GetAssignmentsMineData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    GetAssignmentsMineResponses,
    unknown,
    ThrowOnError
  >({
    url: "/assignments/mine",
    ...options,
  });
};

export const postAssignmentsByIdSubmit = <ThrowOnError extends boolean = false>(
  options: Options<PostAssignmentsByIdSubmitData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>(
    {
      url: "/assignments/{id}/submit",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    }
  );
};

export const postAssignmentsByIdComplete = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<PostAssignmentsByIdCompleteData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).post<
    unknown,
    unknown,
    ThrowOnError
  >({
    url: "/assignments/{id}/complete",
    ...options,
  });
};

export const postAssignmentsByIdAcknowledge = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<PostAssignmentsByIdAcknowledgeData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).post<
    unknown,
    unknown,
    ThrowOnError
  >({
    url: "/assignments/{id}/acknowledge",
    ...options,
  });
};

export const getSharedDocumentsMine = <ThrowOnError extends boolean = false>(
  options?: Options<GetSharedDocumentsMineData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    GetSharedDocumentsMineResponses,
    unknown,
    ThrowOnError
  >({
    url: "/shared-documents/mine",
    ...options,
  });
};

export const getSharedDocumentsMineById = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<GetSharedDocumentsMineByIdData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    GetSharedDocumentsMineByIdResponses,
    unknown,
    ThrowOnError
  >({
    url: "/shared-documents/mine/{id}",
    ...options,
  });
};

export const postSharedDocumentsCreate = <ThrowOnError extends boolean = false>(
  options: Options<PostSharedDocumentsCreateData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    PostSharedDocumentsCreateResponses,
    unknown,
    ThrowOnError
  >({
    url: "/shared-documents/create",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

export const getSharedDocumentsEventByEventId = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<GetSharedDocumentsEventByEventIdData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    GetSharedDocumentsEventByEventIdResponses,
    unknown,
    ThrowOnError
  >({
    url: "/shared-documents/event/{event_id}",
    ...options,
  });
};

export const putSharedDocumentsById = <ThrowOnError extends boolean = false>(
  options: Options<PutSharedDocumentsByIdData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).put<unknown, unknown, ThrowOnError>({
    url: "/shared-documents/{id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

export const postSharedDocumentsByIdGenerate = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<PostSharedDocumentsByIdGenerateData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).post<
    PostSharedDocumentsByIdGenerateResponses,
    unknown,
    ThrowOnError
  >({
    url: "/shared-documents/{id}/generate",
    ...options,
  });
};

export const postSharedDocumentsByIdShare = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<PostSharedDocumentsByIdShareData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).post<
    unknown,
    unknown,
    ThrowOnError
  >({
    url: "/shared-documents/{id}/share",
    ...options,
  });
};

export const postSharedDocumentsByIdUnshare = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<PostSharedDocumentsByIdUnshareData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).post<
    unknown,
    unknown,
    ThrowOnError
  >({
    url: "/shared-documents/{id}/unshare",
    ...options,
  });
};

export const getUser = <ThrowOnError extends boolean = false>(
  options?: Options<GetUserData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    GetUserResponses,
    unknown,
    ThrowOnError
  >({
    url: "/user",
    ...options,
  });
};

export const patchUser = <ThrowOnError extends boolean = false>(
  options: Options<PatchUserData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).patch<
    PatchUserResponses,
    unknown,
    ThrowOnError
  >({
    url: "/user",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

export const getUserInvites = <ThrowOnError extends boolean = false>(
  options?: Options<GetUserInvitesData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    GetUserInvitesResponses,
    unknown,
    ThrowOnError
  >({
    url: "/user/invites",
    ...options,
  });
};

export const getUserTransfers = <ThrowOnError extends boolean = false>(
  options?: Options<GetUserTransfersData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    GetUserTransfersResponses,
    unknown,
    ThrowOnError
  >({
    url: "/user/transfers",
    ...options,
  });
};

export const postUserRequestEmailChange = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostUserRequestEmailChangeData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    PostUserRequestEmailChangeResponses,
    unknown,
    ThrowOnError
  >({
    url: "/user/request-email-change",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

export const postUserConfirmEmailChange = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostUserConfirmEmailChangeData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    PostUserConfirmEmailChangeResponses,
    unknown,
    ThrowOnError
  >({
    url: "/user/confirm-email-change",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

export const getUserTotpStatus = <ThrowOnError extends boolean = false>(
  options?: Options<GetUserTotpStatusData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    GetUserTotpStatusResponses,
    unknown,
    ThrowOnError
  >({
    url: "/user/totp-status",
    ...options,
  });
};

export const postUserSetupTotp = <ThrowOnError extends boolean = false>(
  options?: Options<PostUserSetupTotpData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).post<
    PostUserSetupTotpResponses,
    unknown,
    ThrowOnError
  >({
    url: "/user/setup-totp",
    ...options,
  });
};

export const postUserConfirmTotpSetup = <ThrowOnError extends boolean = false>(
  options: Options<PostUserConfirmTotpSetupData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>(
    {
      url: "/user/confirm-totp-setup",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    }
  );
};

export const postUserDisableTotp = <ThrowOnError extends boolean = false>(
  options: Options<PostUserDisableTotpData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>(
    {
      url: "/user/disable-totp",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    }
  );
};

export const postUserVerifyTotp = <ThrowOnError extends boolean = false>(
  options: Options<PostUserVerifyTotpData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>(
    {
      url: "/user/verify-totp",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    }
  );
};

export const postUserPreferencesResetPdf = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<PostUserPreferencesResetPdfData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).post<
    PostUserPreferencesResetPdfResponses,
    unknown,
    ThrowOnError
  >({
    url: "/user/preferences/reset-pdf",
    ...options,
  });
};

export const getHealth = <ThrowOnError extends boolean = false>(
  options?: Options<GetHealthData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    GetHealthResponses,
    unknown,
    ThrowOnError
  >({
    url: "/health",
    ...options,
  });
};
